/* eslint-disable no-bitwise */

export enum Brand {
  PokerStars = 0x00000001,
  PokerStarsCasino = 0x00000002,
  BetStars = 0x00000004,
  FullTilt = 0x00000040,
  Unknown = 0x00000080,
  PokerStarsVegas = 0x00000100,
  SkyBet = 0x00000200,
  FoxBet = 0x2000
}

export enum Site {
  COM = 0x00000001,
  NET = 0x00000002,
  IT = 0x00000010,
  FR = 0x00000020,
  EE = 0x00000040,
  BE = 0x00000200,
  ES = 0x00000400,
  DK = 0x00000800,
  EU = 0x00001000,
  USNJ = 0x00004000,
  UK = 0x00008000,
  BG = 0x00010000,
  DESH = 0x00020000,
  RO = 0x00080000,
  PT = 0x00100000,
  CZ = 0x00200000,
  RUSO = 0x00400000,
  RUSOPM = 0x00800000,
  IN = 0x01000000,
  ASIA = 0x02000000,
  RU = 0x04000000,
  USPA = 0x08000000,
  SE = 0x10000000,
  CH = 0x20000000,
  ARBA = 0x20000001,
  USCO = 0x20000002,
  DE = 0x20000003,
  USMI = 0x20000004,
  NL = 0x20000005,
  CAON = 0x20000006,
  GR = 0x2000002d
}

// TODO - refactor into generated enum
export enum Country {
  Afghanistan = 'AF',
  Andorra = 'AD',
  Argentina = 'AR',
  Austria = 'AT',
  Belgium = 'BE',
  Bulgaria = 'BG',
  Brazil = 'BR',
  Canada = 'CA',
  Chile = 'CL',
  Estonia = 'EE',
  France = 'FR',
  FrenchGuiana = 'GF',
  Germany = 'DE',
  Gibraltar = 'GI',
  GreatBritain = 'GB',
  Guadeloupe = 'GP',
  Guernsey = 'GG',
  India = 'IN',
  Ireland = 'IE',
  Italy = 'IT',
  Jersey = 'JE',
  Martinique = 'MQ',
  Mayotte = 'YT',
  Mexico = 'MX',
  Netherlands = 'NL',
  Peru = 'PE',
  Reunion = 'RE',
  Romania = 'RO',
  Russia = 'RU',
  Slovenia = 'SI',
  Ukraine = 'UA',
  UnitedKingdom = 'UK',
  UnitedStates = 'US',
  Uruguay = 'UY'
}

export enum PlatformMask {
  WINDOWS = 0x00000001,
  MACOS = 0x00000002,
  IOS = 0x00000004,
  ANDROID = 0x00000008,
  WEB = 0x00000010,
  WEBMOBILE = 0x00000080,
  LINUX = 0x00000020
}

export enum MoneyOption {
  Real,
  Play
}

export enum Vertical {
  Global,
  Account,
  Casino,
  Sports = 4
}

export enum EulaType {
  CombinedEulaPrivacy = 'combinedEulaPrivacy',
  Eula = 'eula',
  GameRulesConditions = 'gameRulesConditions',
  GamingAccAgreement = 'gamingAccAgreement',
  IAmEligibleToPlay = 'iAmEligibleToPlay',
  IndianStatesRestrictions = 'indianStatesRestrictions',
  InformationIsComplete = 'informationIsComplete',
  MarketingMailList = 'marketingMailList',
  PlayerIsNot3Party = 'playerIsNot3Party',
  PlayerIsNotPEP = 'playerIsNotPEP',
  Privacy = 'privacy',
  PlayerFundsProtection = 'playerFundsProtection'
}

export enum PostMessage {
  ACCOUNT_RMF = 'c2l://form/realmoney',
  AGE_VERIFICATION_COMPLETED = 'ps_ageverificationcompleted',
  C2L = 'ps_c2l',
  CLOSE_COMPLETED_RMF = 'ps_closedrmf/complete',
  CLOSE_DEPOSIT = 'ps_closedeposit',
  CLOSE_ICE = 'ps_closeice',
  CLOSE_ID_SCAN = 'ps_closeidscan',
  CLOSE_LICENSE_MIGRATION = 'ps_closelicensemigration',
  CLOSE_MINIGAME = 'ps_closeminigame',
  CLOSE_PMCASHIER = 'ps_closepmcashier',
  CLOSE_SRWRDCHESTS = 'ps_srwrdsCloseChests',
  CLOSE_VIPSTORE = 'ps_closevipstore',
  DEPOSIT_OFFER_BONUS_CODE = 'ps_depositofferbonuscode',
  LICENSE_MIGRATION = 'ps_licensemigration',
  LOGOUT = 'ps_logout',
  NEMID_LOGGEDIN = 'ps_nemid_loggedin',
  OPEN_ACCOUNT = 'ps_openaccount',
  OPEN_BONUSMANAGER = 'ps_openBonusManager',
  OPEN_DEPOSIT = 'ps_opendeposit',
  OPEN_MINIGAME = 'ps_openminigame',
  OPEN_MITID = 'ps_open_mitid',
  OPEN_PAY_WALL = 'ps_openpaywall',
  TWITCH = 'twitch',
  VERIFY_EMAIL = 'ps_verifyemail'
}

export enum CRMZone {
  MY_NEWS = 'WSLTARGETED',
  DOWNLOAD_BANNER = 'WSLMOBILEAPPDOWNLOAD',
  STARS_REWARDS_OPT_IN = 'SWREWARDSOPTIN',
  STARS_REWARDS_INFO = 'SWREWARDSINFO',
  SWC_CANCEL_WD_FROM_DEPOSIT = 'SWCCANCELWDFROMDEPOSIT',
  SWC_CASHIER_MAIN = 'SWCCASHIERMAIN',
  SWC_CONVERSION_RESULT = 'SWCCONVERSIONRESULT',
  SWC_CURRENCY_SETTINGS = 'SWCCURSETTINGS',
  SWC_DEPOSIT_MAIN = 'SWCDEPOSITMAIN',
  SWC_DEPOSIT_RESULT = 'SWCDEPOSITRESULT',
  SWC_OVER_CREDIT = 'SWCOVERCREDIT',
  SWC_P2P_RESULT = 'SWCP2PRESULT',
  SWC_TRANSACTION_HISTORY = 'SWCTXNHISTORY',
  SWC_TRANSITION_TO_WC2 = 'SWCTRANSITIONTOWC2',
  SWC_WITHDRAW_RESULT = 'SWCWDRESULT',
  SWC_WELCOME_BONUS = 'SWCWELCOMEBONUS',
  WSL_WELCOME_OFFER_POPUP = 'WSLWELCOMEOFFERPOPUP1',
  WSL_WELCOME_OFFER_ICON = 'WSLWELCOMEOFFERICON'
}

export enum Header {
  Auth = 'x-stars-authenticated',
  Brand = 'x-stars-brand',
  Cache = 'x-skip-cache',
  Country = 'x-stars-geo-country',
  Currency = 'x-stars-currency',
  Device = 'x-device',
  Embedded = 'x-stars-embedded',
  Forwarded = 'x-forwarded-for',
  Host = 'x-forwarded-host',
  IspAccountCountry = 'x-isp-account-country',
  IspPromotionsPermitted = 'x-isp-promotions-permitted',
  IspFeatures = 'x-isp-feature-flag',
  OddsFormat = 'x-stars-odds-format',
  Locale = 'x-stars-locale',
  OS = 'x-os-family',
  PowResult = 'pow-result',
  Protocol = 'x-forwarded-proto',
  Region = 'x-stars-region',
  Render = 'x-stars-render',
  RequestId = 'x-request-id',
  Site = 'x-stars-site',
  State = 'x-stars-geo-state',
  TimeZone = 'x-stars-time-zone',
  FiSiteId = 'x-fi-ps-site-id',
  FiDeviceId = 'x-fi-ps-device-id',
  FiOsId = 'x-fi-ps-os-id',
  FiBrandId = 'x-fi-ps-brand-id',
  FiInstallId = 'x-fi-ps-install-id',
  FiAppTypeId = 'x-fi-ps-app-type-id',
  FiProductId = 'x-fi-ps-product-id',
  FiPlatformId = 'x-fi-ps-platform-id'
}

export enum Size {
  XXSmall = 'xxs',
  XSmall = 'xs',
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
  XXLarge = 'xxl'
}

export enum Source {
  Direct = 'Direct',
  Affiliate = 'Affiliate',
  Adwords = 'Adwords',
  Display = 'Display',
  SEO = 'SEO'
}

export enum ResolverTag {
  ANJRGExclude = 'anj-rg-exclude',
  ATSBaseUrl = 'ats-api',
  ATSBootstrap = 'ats-bootstrap',
  ATSCss = 'ats-css',
  AccountEmailValidationCode = 'account-email-validation-code',
  AccountHistoryStatement = 'account_history_statement',
  AccountPIN = 'pokerstars-pin',
  AccountResponsible = 'account-responsible',
  AmountWithdrawHelp = 'wdl-policy-general',
  AddressChangeSupport = 'address-change-support',
  AvailableWithdrawFaq = 'available-withdraw-faq',
  BeGambleAwareLogo = 'be-gamble-aware-logo',
  BonusesReleaseAndInstant = 'bonuses-release-and-instant',
  BonusWheelGame = 'bonuswheel_game',
  CAONSignup = 'caon_signup',
  CAONRedirect = 'caon_mob_redirect',
  CasinoAssetWrapper = 'casino-asset-wrapper',
  CasinoRedemption = 'sr_casino_redemption',
  CasinoSlots = 'casino-slots',
  Cashbonus = 'cashbonus',
  ChestAssets = 'chest_assets',
  CloseAccount = 'cs-account-closure',
  CommunityForumBaseURL = 'CommunityForumBaseURL',
  CommunityForumLoginURL = 'communityforumcustomloginpageurl',
  ConnexOntario = 'connex_ontario',
  ContactSupport = 'contact-support',
  RealMoneyResortsCasino = 'realmoney_resortscasino',
  ContactSupportCashierTroubleDeposit = 'contact-support-cashier-trouble-deposit',
  ContactSupportStella = 'contact_support_stella',
  Cookies = 'cookies',
  CRMStarCode = 'crm_starcode',
  CSPasswordReset = 'cs-password-reset',
  CSResponsibleExclusion = 'cs-responsible-exclusion',
  Davos = 'davos',
  DFAccountResponsibleGaming = 'about-rg-cashier-logo',
  DFSecuritySecurityDocumentRequest = 'df_security_securitydocumentrequest',
  DKRegulatorLogo = 'dk_dga_logo',
  EEPopulationRegister = 'ee_population_register',
  ExchangeMybets = 'exchange-mybets',
  ExchangeHome = 'exchange-home',
  ExchangeWhiteLabel = 'exchange_white_label',
  EligibleEula = 'eligible_eula',
  FailedPow = 'failed-pow',
  FreeSpinBonus = 'free-spins-bonuses',
  FreeSpinBonusTermsBonus = 'freespinbonus_terms_bonus',
  FreeSpinBonusTermsBonusCap = 'freespinbonus_terms_bonus_cap',
  FreeSpinBonusTermsCash = 'freespinbonus_terms_cash',
  FreeSpinBonusTermsCashCap = 'freespinbonus_terms_cash_cap',
  FreemiumBuyPlayChips = 'freemium-buy-play-chips',
  GamCareHelplineLogo = 'gamcare-helpline-logo',
  GambanUK = 'gamban_uk',
  GambleAware = 'gamble_aware',
  GamcareTest = 'gamcare_rgtest',
  GameSecurity = 'df_security_gamesecurity',
  GamingAccountAgreement = 'gaming_account_agreement',
  GamingLabsLogo = 'gaming-labs-logo',
  RealMoneyMuchBetterSignUpGdpr = 'realmoney_muchbetter_signup_gdpr',
  GeoAssist = 'geo-assist',
  GrLimitNotIfPrompt = 'gr-limitnotif-prompt',
  GordonMoodyLogo = 'gordon-moody-logo',
  HcCurrencyMgt = 'hc_currency_mgt',
  HcTransfersIssues = 'hc-transfers-issues',
  HelpCenter = 'help-center',
  HelpCenterAccountValidation = 'help_center_account_validation',
  HelpCenterChatBotScript = 'hc-chat-bot-script',
  HelpCenterChatBotUrl = 'hc-chat-bot-url',
  HelpCenterDepositWithdrawal = 'hc_dep_wd',
  HelpCenterESDecree = 'help-center-esdecree',
  HelpCenterFeedback = 'hc-feedback',
  HelpCenterP2pTransfer = 'hc_transf',
  HelpEmails = 'help_emails',
  HelpFaqGeolocation = 'help_faq_geolocation',
  HelpGamecare = 'help_gamcare',
  HelpGameSportsRules = 'help_games_sports_rules',
  HelpMGA = 'help_mga',
  AboutRgCashierLogo = 'about-rg-cashier-logo',
  HelpResponsibleGaming = 'help_responsiblegaming',
  HelpRGAccredation = 'help_rg_accredation',
  HelpRGRegulatorSE = 'help_rg_regulator_se',
  HelpRGSE = 'help_rg_se',
  HomeGamesInvite = 'homegames_invite',
  HorseRacingRules = 'sportsbook-isp-horseracing-rules',
  SaGGameRules = 'game-rules-sag',
  MTTGameFilters = 'game-filters-template',
  IbasLogo = 'ibas-logo',
  IbiaLogo = 'ibia-logo',
  Ice2Home = 'ice-home2',
  IceHome = 'ice-home',
  IceLeaderboards = 'ice-leaderboards',
  IdscanServerUrl = 'idscan-server-url',
  IdscanHostedUrl = 'idscan-hosted-url',
  IGamingOntario = 'igaming-ontario',
  InstantBonus = 'instant-bonuses',
  InstantBonusSplitWagerTermsCash = 'Instantbonus_splitwager_terms_cash',
  InstantBonusSplitwagerTermsCash = 'instantBonus_splitwager_terms_cash',
  InstantBonusSplitWagerTermsCashCap = 'Instantbonus_splitwager_terms_cash_cap',
  InstantBonusSplitwagerTermsCashCap = 'instantbonus_splitwager_terms_cash_cap',
  InstantBonusTermsCash = 'instantbonus_terms_cash',
  InstantBonusTermsCashCap = 'instantbonus_terms_cash_cap',
  InstantBonusTermsPurchase = 'instantbonus_terms_purchase',
  ISPFreeBets = 'ispfreebets',
  Joueurs = 'joueurs',
  LiveChatSupport = 'live-chat-support',
  LostRSAToken = 'lost_rsa_token',
  MatchDayMillions = 'matchdaymillions_game',
  MCEula = 'mc_eula',
  MCEulaARStates = 'mc_eula_ar_states',
  MCPrivacy = 'mc_privacy',
  MCVipStore = 'mc_vipstore',
  MigrationWithdraw = 'migration_withdraw',
  MinigameTicket = 'mini-game-tickets',
  MitIDRedirect = 'mitid-redirect',
  NPSSubmission = 'stars_nps_submission',
  NPSDismissal = 'stars_nps_dismissal',
  NPSFollowUp = 'stars_nps_follow_up',
  NwWithdrawRestricted = 'nw-withdraw-restricted',
  OasisReinstate = 'OASIS_reinstate',
  OpenBankidValidation = 'open_bankid_validation',
  PanicButtonHelpArticle = 'de-vegas-panic-button-help-article',
  PaymentInstrumentDocuments = 'payment_instrument_documents',
  PickObjectGame = 'pickobject_game',
  PlayerLocationCheck = 'player_location_check',
  PlayerProtectionPage = 'player-protection-page',
  PlayingInsightsMvpSurvey = 'playing_insights_mvp_survey',
  PlayTheDeal = 'play-the-deal-webui',
  PRMCasinoPromoTerms = 'prm_casino_promo_terms',
  PRMCasinoRacesIngame = 'prm_casino_races_ingame',
  PRMPSCasinoDownload = 'prm_pscasino_download',
  ProcessingExchangeTerms = 'processing-exchange-terms',
  ProcessingTime = 'hc-wd-processing-time',
  PMCPaywall = 'pmc_paywall',
  PSDownload = 'ps-download',
  PSMessenger = 'ps-messenger',
  PTBlacklist = 'pt_blacklist',
  Rollback = 'hc-rollback',
  RamConfig = 'ram_config_url',
  RamCounselingCenter = 'ram_counseling_center',
  RamGamblingTherapy = 'ram_gambling_therapy',
  RamUtils = 'ram_require_js',
  RealMoney = 'realmoney',
  RealMoneyAgeVerificationFaq = 'realmoney_ageverification_faq',
  RealMoneyEcheckTerms = 'realmoney_echeck_terms',
  RealMoneyMuchBetterSignUp = 'realmoney_muchbetter_signup',
  RealMoneyPspayAstropayRate = 'realmoney_pspay_astropay_rate',
  RealMoneySecurityFaq = 'realmoney_security_faq',
  ResponsibleGamingLogoBe = 'responsible-gaming-logo-be',
  ResponsibleGamingPokerLimit = 'responsible_gaming_poker_limit',
  ResponsibleGamingQuestion = 'cs-responsible-question',
  RGNJOAG = 'rg_njoag',
  RG18Logo = 'rg18-logo',
  RGPage = 'mc_responsible',
  RGQuestion = 'rg_question',
  RGRegulatorSE = 'rg_regulator_se',
  SalesforceChatSrc = 'salesforce_chat_src',
  SalesforceChatScrt = 'salesforce_chat_scrt',
  SalLgo = 'sal-logo',
  SecAccountRestricted = 'sec_account_restricted',
  SecurityAgeVerification = 'security-age-verification',
  SelfExclusionGamStop = 'self-exclusion-gamstop',
  SelfExclusionInformation = 'self-exclusion-information',
  SelfExclusionMerger = 'self-exclusion-merger',
  SelfExclusionResponsibleGamingFT = 'self-exclusion-rg-page-fulltilt',
  SelfExclusionResponsibleGamingPS = 'self-exclusion-rg-page-ps',
  SicadPT = 'sicad-pt',
  SingleReelGame = 'singlereel_game',
  SolLgo = 'sol-logo',
  SportsBookFreeBets = 'sportsbook-freebets',
  SportsBookExchange = 'sportsbook-exchange',
  SportsCashBonusTerms = 'bonuscash-terms',
  SrijRIG = 'srij-rig',
  StarCode = 'star-code',
  StarsCrmCdnBaseUrl = 'starscrm_cdn_baseurl',
  StarsRewardsWidgetService = 'starsrewards_widgetservice',
  StarsWeb = 'stars_web',
  StarsWebApi = 'starsweb_api',
  StarsWebCasino = 'starsweb_casino',
  StarsWebMinilobby = 'starsweb_minilobby',
  StarsWebPoker = 'starsweb_poker',
  StarsWebSports = 'starsweb_sports',
  SubmitDocuments = 'submit-documents',
  SubmitDocumentsVerifications = 'submit-documents-verifications',
  SwcCallbackRedirect = 'swc_callback_redirect',
  SwcContactSupportRestrictedAccount = 'swc-contact-support-restricted-account',
  SwcManageCurrencies = 'swc-manage-currencies',
  SwcSubmitDocumentsVerifications = 'swc-submit-documents-verifications',
  SwcWithdrawalDecline = 'swc-withdrawal-decline',
  TwitchAuthorize = 'twitch_authorize',
  UKGamstopMain = 'uk_gamstop_main',
  UKLicenseAccountNumber = 'uk_license_account_number',
  VerifyMeAML = 'verify-me-aml',
  VanillaDirectStoreLocator = 'vanilla_direct_store_locator',
  WC2FEBalance = 'wc2fe_balance',
  WC2FEConvertCurrencies = 'wc2fe_convert_currencies',
  WC2FEDeposit = 'wc2fe_deposit',
  WC2FEHistory = 'wc2fe_history',
  WC2FEHome = 'wc2fe_home',
  WC2FEPlayMoney = 'wc2fe_playmoney',
  WC2FEPreferredCurrency = 'wc2fe_preferred_currency',
  WebPoker = 'web_poker',
  WebRealMoneyForm = 'web-real-money-form',
  Withdrawal = 'wc2fe_cashout',
  WrmfTelematiciFiscal = 'wrmf_telematici_fiscal',
  XeWebSite = 'xe_web_site',
  PlayerFundsProtection = 'playerFundsProtection'
}

export enum FormMethod {
  Post = 'post',
  Get = 'get'
}

export enum TokenType {
  Invalid,
  Cashier,
  Freemium,
  CustomerSupport,
  ICE,
  Casino,
  RAM,
  WebAccountService,
  VIPStore,
  RationalWebServices,
  DFSports,
  PokerDuel,
  FTPMigrate,
  Storm,
  PoolBetting
}

// TODO remove RoutingKey
export enum RoutingKey {
  CasinoGameInfo = 'CasinoGameInfo',
  FirstWalletHome = 'FirstWalletHome',
  HelpCenter = 'HelpCenter',
  HelpCenterArticle = 'HelpCenterArticle',
  HelpCenterCategoryArticles = 'HelpCenterCategoryArticles',
  HelpCenterSearchArticles = 'HelpCenterSearchArticles',
  Home = 'Home',
  CasinoHome = 'CasinoHome',
  PokerHome = 'PokerHome',
  SportsHome = 'SportsHome',
  HomeGamesCashGames = 'HomeGamesCashGames',
  HomeGamesClubs = 'HomeGamesClubs',
  HomeGamesPublicClubs = 'HomeGamesPublicClubs',
  HomeGamesInvite = 'HomeGamesInvite',
  HomeGamesLandingPage = 'HomeGamesLandingPage',
  HomeGamesTournaments = 'HomeGamesTournaments',
  SportsCompetition = 'SportsCompetition',
  SportsCompetitionOutrights = 'SportsCompetitionOutrights',
  SportsEmbeddedHistoricalBets = 'SportsEmbeddedHistoricalBets',
  SportsEmbeddedMyBets = 'SportsEmbeddedMyBets',
  SportsEmbeddedSettings = 'SportsEmbeddedSettings',
  SportsEvent = 'SportsEvent',
  sportsEventResults = 'sportsEventResults',
  SportsExchange = 'SportsExchange',
  SportsGolfCompetitions = 'SportsGolfCompetitions',
  SportsGolfMatches = 'SportsGolfMatches',
  SportsGreyhoundRacingFuture = 'SportsGreyhoundRacingFuture',
  SportsGreyhoundRacingFutureMarket = 'SportsGreyhoundRacingFutureMarket',
  SportsGreyhoundRacingMeetings = 'SportsGreyhoundRacingMeetings',
  SportsGreyhoundRacingNext = 'SportsGreyhoundRacingNext',
  SportsGreyhoundRacingRace = 'SportsGreyhoundRacingRace',
  SportsHiddenPromotion = 'SportsHiddenPromotion',
  SportsHiddenPromotions = 'SportsHiddenPromotions',
  SportsHistoricalBets = 'SportsHistoricalBets',
  SportsHorseRacingFuture = 'SportsHorseRacingFuture',
  SportsHorseRacingFutureMarket = 'SportsHorseRacingFutureMarket',
  SportsHorseRacingMeetings = 'SportsHorseRacingMeetings',
  SportsHorseRacingNext = 'SportsHorseRacingNext',
  SportsHorseRacingRace = 'SportsHorseRacingRace',
  SportsInPlay = 'SportsInPlay',
  SportsInPlaySport = 'SportsInPlaySport',
  SportsMatchFiltering = 'SportsMatchFiltering',
  SportsMyBets = 'SportsMyBets',
  sportsOddsBoost = 'sportsOddsBoost',
  SportsPromotion = 'SportsPromotion',
  SportsPromotions = 'SportsPromotions',
  SportsSelfExcluded = 'SportsSelfExcluded',
  SportsSelfExcludedHistoricalBets = 'SportsSelfExcludedHistoricalBets',
  SportsSelfExcludedMyBets = 'SportsSelfExcludedMyBets',
  SportsSettings = 'SportsSettings',
  SportsSpecials = 'SportsSpecials',
  SportsSport = 'SportsSport',
  SportsSportInPlay = 'SportsSportInPlay'
}

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark'
}

export enum UILayout {
  Table = 'table',
  Grid = 'grid'
}

export enum DocumentType {
  Passport,
  DrivingLicense,
  NationalIDCard
}

export enum DebugKey {
  Frame = 'stars:frame',
  Request = 'stars:request',
  RequestInfo = 'stars:request:info',
  Socket = 'stars:socket',
  Wizard = 'stars:wizard',
  Embedded = 'stars:embedded',
  GeoComply = 'stars:geoComply',
  Error = 'stars:error',
  Bridge = 'stars:bridge',
  Monitor = 'stars:monitor',
  VaderArgs = 'vader:args',
  VaderServer = 'vader:server',
  VaderState = 'vader:state',
  VaderOneTrust = 'vader:one-trust',
  VaderCallback = 'vader:callback',
  VaderManifest = 'vader:manifest',
  VaderPage = 'vader:page',
  VaderPreview = 'vader:preview',
  VaderWebsite = 'vader:website',
  VaderWidget = 'vader:widget',
  SdkSocket = 'sdk:socket',
  SdkRequest = 'sdk:request',
  RgError = 'rgError:sePT',
  MockServer = 'mock:server'
}

export enum FeatureFlag {
  ABTestPlayingInsightsProfitLoss = 'abtest_playing_insights_profitloss',
  AccountCreatedContinue = 'AccountCreatedContinue',
  AccountChangeMobile = 'account_change_mobile',
  Add2HomeScreen = 'a2hs',
  AddressUpdateDisabled = 'address-update-disabled',
  AMLLoginMsg = 'aml-login-msg',
  AMLLoginMsgVerified = 'aml-login-msg-verified',
  AllowSoftRedirectCancel = 'allow-soft-redirect-cancel',
  BankID = 'se-bankid-signup',
  BlackListCheck = 'blacklist-check',
  CasinoFavorites = 'CasinoFavorites',
  CasinoFreeSpinsToken = 'CasinoFreeSpinsToken',
  CasinoGameFeatureBonusFeatures = 'CasinoGameFeatureBonusFeatures',
  CasinoGameFeatureMaxBet = 'CasinoGameFeatureMaxBet',
  CasinoGameFeatureMinBet = 'CasinoGameFeatureMinBet',
  CasinoGameFeatureMultiplier = 'CasinoGameFeatureMultiplier',
  CasinoGameFeaturePaylines = 'CasinoGameFeaturePaylines',
  CasinoGameFeatureRTP = 'CasinoGameFeatureRTP',
  CasinoGameFeatureWilds = 'CasinoGameFeatureWilds',
  CasinoGameInfo = 'CasinoGameInfo',
  CasinoGameInfoDescription = 'CasinoGameInfoDescription',
  CasinoInstantBonusesToken = 'CasinoInstantBonusesToken',
  CasinoLimits = 'eCasinoLimits',
  CasinoLiveRacesTCReqd = 'CasinoLiveRacesTCReqd',
  CasinoLiveRoulette = 'CasinoLiveRouletteResultsFeed',
  CasinoNonAuth = 'eCasinoNonAuth',
  CasinoRewardsStoreToken = 'CasinoRewardsStoreToken',
  CasinoSlotRacesTCReqd = 'CasinoSlotRacesTCReqd',
  CasinoSpinOfDay = 'CasinoSpinOfTheDay',
  Chest = 'chestPageEnabled',
  CommunityForum = 'CommunityForumLinksInHeaderAndFooter',
  CrossOperatorInactiveStatus = 'CrossOperatorInactiveStatus',
  CustomPIN = 'custom-pin',
  DEAllowed = 'DE_Allowed',
  DELossLimit = 'DE_losslimit',
  DEPanic = 'DE_Panic',
  DESpendLimit = 'DE_SpendLimit',
  DisableBuenosAiresFeatures = 'DisableBuenosAiresFeatures',
  DisableNewUkAgeVerificationFlow = 'DisableNewUkAgeVerificationFlow',
  DisablePendingWithdrawalCancellation = 'swc-disable-pending-withdrawal-cancellation',
  DisableRam = 'DisableRam',
  DivertRAMToPoker = 'DivertRAMToPoker',
  DocumentsRequestPrompt = 'document_request_prompt',
  DynamicCmsBanners = 'DynamicCmsBanners',
  EnableATSExchangeBetsLink = 'EnableATSExchangeBetsLink',
  EnableATSLegacyPreferences = 'EnableATSLegacyPreferences',
  EnableATSMaintenance = 'EnableATSMaintenance',
  EnableExchange = 'EnableExchange',
  EnableOneTrust = 'enableOneTrust',
  EnableSentry = 'enableSentry',
  ESActivitySummaryReport = 'ES_ActivitySummaryReport',
  ESportsBookAuth = 'eSportsBookAuth',
  EuDeOasisStreetAddress = 'EUDE_Oasis_Street_Address',
  FixedPrizeDrawNotificationEnabled = 'FixedPrizeDrawNotificationEnabled',
  FooterDateTime = 'footer_date_time',
  ForceDefaultLocale = 'ForceDefaultLocale',
  FreeBets = 'freebets',
  GreyhoundRacingEnabled = 'ISP_GreyhoundRacingEnabled',
  ISPMyStarsFreeBets = 'Visibility_MyStars_FreeBets',
  Freemium = 'eFreemium',
  FreemiumMobile = 'eFreemiumMobile',
  FreeSpins = 'eFreeSpinsBonuses',
  HandHistoryRAMMyHandHistoryRequests = 'HandHistory_RAM_MyHandHistoryRequests',
  HideRemoveSlfImpLimit = 'hide_RemoveSlfImpLimit',
  HideRsaTokenMenu = 'hideRsaTokenMenu',
  HideStarsPinMenu = 'hideStarsPinMenu',
  HomeGamesNewTab = 'HomeGamesNewTab',
  HorseRacingEnabled = 'ISP_HorseRacingEnabled',
  Ice2Feature = 'ice2',
  IceFeature = 'eIceFeatureEnabled',
  IceLeaderboard = 'eIceLeaderBoard',
  IdpSecondaryLoginEnabled = 'idp-secondary-login-enabled',
  IDScanSDK = 'IDScan-SDK',
  IDScanHosted = 'IDScan-Hosted',
  InstantBonusesVisibility = 'Visibility_MyStars_InstantBonuses',
  ISPAmericanOdds = 'ISP_AmericanOdds',
  ISPBetBuilder = 'ISP_BetBuilder',
  ISPBetBuilderNewTag = 'ISP_BetBuilderNewTag',
  ISPBonusCash = 'ISP_BonusCash',
  ISPCashOut = 'ISP_CashOut',
  ISPDataVisualisation = 'ISP_DataVisualisation',
  ISPDisplayEventsWithoutMappedMarkets = 'ISP_DisplayEventsWithoutMappedMarkets',
  ISPDynamicAlternates = 'ISP_DynamicAlternates',
  ISPHistoricalBets = 'ISP_HistoricalBets',
  ISPICEPromotions = 'ISP_ICE_Promotions',
  ISPSportLandingPage = 'ISP_Release_SportLandingPage',
  ISPMigrationBanner = 'ISP_Migration_Banner',
  ISPPromotionPicker = 'ISP_PromotionPicker',
  ISPPromotions = 'ISP_Promotions',
  ISPQuickSwitcher = 'ISP_QuickSwitcher',
  ISPReleaseRestrictedMinOdds = 'ISP_Release_RestrictedMinOdds',
  ISPRouting = 'ISP_Routing',
  ISPScoreboards = 'ISP_Scoreboards',
  ISPSportsFreeBets = 'ISP_FreeBets',
  ISPStatusCheck = 'ISP_StatusCheck',
  ISPUnauthenticatedPromotionsQuickLink = 'ISP_UnauthenticatedPromotionsQuickLink',
  JWTEnabled = 'JWTEnabled',
  LiveChatSupport = 'eLiveChatSupport',
  LoginSEDialogue = 'loginSEDialogue',
  LoginSummaryNotificationModification = 'login-summary-notification-modification',
  LoyaltyWidgetRefresh = 'Loyalty_WidgetRefresh',
  LowBalancePrompt = 'wc2-balance-low-prompt',
  MiniGameTickets = 'eMiniGameTickets',
  NewContactSupportForm = 'newCsf',
  NoLanguages = 'noLanguages',
  NoCasinoGameHistory = 'noCasinoGameHistory',
  NoPokerStarsRewards = 'noPokerStarsRewards',
  NPS = 'SW-SimpleNPS',
  NPSPhase2 = 'SW-NPSPhase2',
  PmcPaywall = 'pmc-paywall',
  PRHub = 'PromoExp_PromotionsAndRewards',
  PSMessenger = 'PSMessenger',
  PSMessengerConfig = 'PSMessengerConfig',
  PSMessengerToggle = 'PSMessengerToggle',
  PSMessengerIgnoreLogin = 'PSMessengerIgnoreLogin',
  PlayMoney = 'playMoney',
  PredictorGame = 'predictorGameEnabled',
  PublicLiveChatSupport = 'ePublicLiveChatSupport',
  PKRHomeGamesGameTilesUnsupported = '2022.Q2.Poker.HomeGames.GameTiles.WEB-10835',
  PKRHomeGamesOnboardingCreateGame = '2022.Q2.Poker.HomeGames.OBCreateGame.POKER-348',
  PKRHomeGamesOnboardingFirstTime = '2022.Q3.Poker.HomeGames.OBFirstTimeUX.POKER-378',
  PKRHomeGamesOnboardingJoinClub = '2022.Q2.Poker.HomeGames.OBJoinClub.POKER-371',
  PKRHomeGamesNewSideBar = '2022.Q3.Poker.HomeGames.Sidebar.POKER-258',
  PKRHomeGamesVideoChatToggleRedesign = '2022.Q4.Poker.HomeGames.VideoChatToggleRedesign.POKER-2012',
  PKRHomeGamesPublicClubs = '2022.Q4.Poker.HomeGames.PublicClubs.POKER-1917',
  PKRHomeGamesJoinAndCreatePublicClubs = '2023.Q4.Poker.HomeGames.JoinAndCreatePublicClubs.POKER-9619',
  PKRHomeGamesQuickCreateTournament = '2022.Q3.Poker.HomeGames.QuickCreateTournament.POKER-1797',
  PKRHomeGamesTheWall = '2022.Q4.Poker.HomeGames.TheWall.POKER-1645',
  PKRHomeGamesLightMode = '2022.Q4.Poker.HomeGames.LightMode.POKER-2246',
  PKRHomeGamesPublicClubSearch = '2023.Q1.Poker.HomeGames.BasicSearch.POKER-252',
  PKRHomeGamesEmptyStateSideWall = '2023.Q1.Poker.HomeGames.RighSideBar.POKER-5484',
  PKRMultiTableTournamentsVisibility = '2023.Q4.Poker.WebMTT.Visibility.POKER-8355',
  PKRSpinAndGoMaxHoldemAvailable = '2023.Q4.Poker.WebSAG.MaxHoldemAvailable.POKER-8580',
  PKRSpinAndGoOmahaAvailable = '2023.Q4.Poker.WebSAG.OmahaAvailable.POKER-8580',
  PKRSpinAndGoWatchGamesVisibility = '2023.Q4.Poker.WebSAG.WatchGamesVisibility.POKER-7799',
  ReleaseBonuses = 'ReleaseBonuses',
  ResolverRewriteForWC2 = 'resolver-rewrite-for-wc2',
  RestrictSeWeeklyLimit = 'restrict-se-weekly-limit',
  RewardsStore = 'Visibility_MyStars_RewardsStore',
  RGLugasDepositLimit = 'RGLugasDepositLimit',
  RmfEmployerInfo = 'rmf-employer-info',
  SelfExclusionNewDesign = 'SelfExclusionNewDesign',
  SeparatedEulaPrivacyPolicy = 'separated_eula_privacy_policy',
  SessionPopupExtended = 'sessionPopupExtended',
  SFConfig = 'SFConfig',
  SFToggle = 'SFToggle',
  ShowJackpotWheel = 'Show-Jackpot-Wheel',
  SignUpShowState = 'SignUpShowState',
  SkyBetSports = 'sky-bet-sports',
  SnowplowAnalytics = 'snowplow-analytics',
  SportsBonusCash = 'Visibility_MyStars_BonusCash',
  SportsBookLimits = 'eSportsBookLimits',
  SportsBookNonAuth = 'eSportsBookNonAuth',
  SportsNonAuth = 'sports-non-auth',
  SportsBookOptions = 'eSportsBookOptions',
  SwcAffiliateBonus = 'swc-affiliate-bonus',
  SwcCreditTime = 'swc-credit-time',
  SwcDeposit = 'swc-deposit',
  SwcDepositLimitButtonDisplay = 'swc-depositlimit-button-display',
  SwcDepositMethodMinimum = 'swc-deposit-method-minimum',
  SwcDepositReloader = 'swc-deposit-reloader',
  SwcDispalyAutoConversionCTA = 'swc-display-autoconversion-cta',
  SwcECheckConfirmation = 'swc-eCheck-confirmation',
  SwcEmailVerification = 'swc-email-verification',
  SwcExitFlow = 'swc-exit-flow',
  SwcExploreCta = 'swc-explore-cta',
  SwcManageCurrencies = 'swc-manage-currencies',
  SwcPaypalSandboxQA = 'swc-paypal-sandbox-qa',
  SwcP2pTransfer = 'swc-p2ptransfer',
  SwcReloaderBonus = 'swc-reloader-bonus',
  SwcRmfAddressSearch = 'swc-rmf-address-search',
  SwcRmfNoLimits = 'swc-rmf-no-limits',
  SwcRMFPhoneVerification = 'swc-rmf-phone-verification',
  SwcRmfShowOnlyWeeklyLimit = 'swc-rmf-show-only-weekly-limit',
  SwcSignupOnePage = 'swc-signup-onepage',
  SwcSignup = 'swc-signup',
  SwcSignupDeposit = 'swc-signup-deposit',
  SwcSignupRmfEcopokerLobby = 'swc_signup_rmf_ecopokerlobby',
  SwcSignupRmf = 'swc-signup-rmf',
  SwcSignupRmfEcoEransitionTwo = 'swc-signup-rmf-ecotransitiontwo',
  SwcSignupPhoneCollection = 'swc-signup-phone-collection',
  SwcSignupRmfSumSub = 'swc-signup-rmf-sumsub',
  SwcTransactionHistoryFilters = 'swc-transaction-history-filters',
  SwcCashier = 'swc-cashier',
  SwcOnboardingProgressbar = 'swc-onboarding-progressbar',
  SwcWelcomeBonusScreen = 'swc-welcomebonus-screen',
  SwcWithdrawal = 'swc-withdrawal',
  SwcSignupRmfAutofocus = 'swc-signup-rmf-autofocus',
  SwcWithdrawalCreditTime = 'swc-withdrawal-credit-time',
  SwcWithdrawalMethodMinimum = 'swc-withdrawal-method-minimum',
  SwcXpayLibraryTestStatus = 'swc-xpay-library-test-status',
  TemporaryLoginTimeLimit = 'temporaryLoginTimeLimit',
  TheDeal = 'the-deal',
  TheDealHighRoller = 'the-deal-highroller',
  TwitchConnect = 'TwitchConnect',
  UseRam1 = 'UseRam1',
  VerifyAccount = 'verify-account',
  VerifyAccountAfterRmf = 'verify-account-after-rmf',
  VerifyAccountDrivingLicense = 'verify-account-driving-license',
  VerifyAccountNationalId = 'verify-account-national-id',
  VerifyAccountPassport = 'verify-account-passport',
  VisibilityOASISExclusionOption = 'visibility_OASIS_exclusion_option',
  VisibilityPlayingInsights = 'Visibility_Playing_Insights',
  VisibilityPlayingInsightsLoginPopup = 'Visibility_Playing_Insights_Login_popup',
  VisibilityRestrictWithdrawalCancellation = 'visibility_restrict_withdrawal_cancellation',
  Wc2PlayMoney = 'wc2-playmoney',
  WebMPCNotificationEnabled = 'WebMPCNotificationEnabled',
  WebNotificationEnabled = 'WebNotificationEnabled',
  WrmfAcAutotrigger = 'wrmf-ac-autotrigger',
  VerifyDoc = 'verify-doc',
  VegasPanicButtonDialogNewText = 'de-vegas-panic-button-dialog-new-text'
}

export enum LimitType {
  POKER = 5,
  POKER_TIME = 31,
  SPORT = 15
}

export enum SuspendAccountCode {
  ExclusionList = '1',
  Blacklisted = '4',
  Suspended = '24',
  PlayerNotAuthorized = '1233'
}

export enum NetDepositLimitGroup {
  Unknown = 0,
  YoungUser = 1,
  NewUser = 2,
  ExistingUser = 3
}

export enum GADimension {
  AffiliateCode = 'dimension1',
  License = 'dimension3',
  LangId = 'dimension5',
  ResolverTag = 'dimension10',
  GClientID = 'dimension11',
  WebClientID = 'dimension12',
  ACID = 'dimension13',
  WebIDHit = 'dimension14',
  TimeStamp = 'dimension15',
  SizmekID = 'dimension16',
  MaxymiserID = 'dimension17',
  SignalID = 'dimension18',
  WebIDSession = 'dimension20',
  PromoIA = 'dimension21',
  MSClickID = 'dimension22',
  MachineID = 'dimension25',
  ClientID = 'dimension26',
  SizmekClickID = 'dimension27',
  BrandCode = 'dimension30',
  ApplicationType = 'dimension32',
  DataSource = 'dimension33',
  ApplicationVersion = 'dimension36',
  StarsCardPhysicalCardHolder = 'dimension46',
  UIElementId = 'dimension47',
  UIElementTypeId = 'dimension48',
  UIElementName = 'dimension49',
  UIElementTitle = 'dimension50',
  UIElementLocation = 'dimension51',
  UIElementPosition = 'dimension52',
  UIElementExtendedAttributes = 'dimension53',
  VisitId = 'dimension55',
  IsRMplayer = 'dimension62',
  IsPMplayer = 'dimension63',
  BrandName = 'dimension64',
  SiteName = 'dimension65',
  HostApplicationType = 'dimension66',
  HostApplicationVersion = 'dimension67',
  FacebookClickId = 'dimension73',
  FacebookBrowserId = 'dimension74',
  MoneyType = 'dimension75',
  PageOriginPath = 'dimension76',
  GameName = 'dimension80',
  GameCode = 'dimension81',
  GameTags = 'dimension82',
  GamePlayMode = 'dimension83',
  GameJackpot = 'dimension84',
  GamesInView = 'dimension85',
  GamesTotal = 'dimension86',
  GameVariantID = 'dimension87',
  TabName = 'dimension90',
  WidgetName = 'dimension91',
  LaunchSource = 'dimension92',
  IsFavourite = 'dimension96',
  ActiveTab = 'dimension97',
  ModalContent = 'dimension98',
  WidgetContents = 'dimension99',
  Profit = 'dimension100',
  CampaignID = 'dimension101',
  InputValue = 'dimension102',
  RadioButtonActive = 'dimension103',
  HSPOrFeatureFlags = 'dimension104',
  PlayerCurrency = 'dimension105',
  Amount = 'dimension106',
  ErrorsTracked = 'dimension107',
  GameTicketNumber = 'dimension108',
  TabPosition = 'dimension109',
  AMSPromoCode = 'dimension114',
  TicketID = 'dimension116',
  DepositStatus = 'dimension118',
  DepositRedirectStatus = 'dimension119',
  DepositGateway = 'dimension120',
  TransactionType = 'dimension121',
  TransactionStatus = 'dimension122',
  Conversion = 'dimension123',
  TransactionDate = 'dimension124',
  TransactionId = 'dimension125',
  PaysystemName = 'dimension126',
  PreviouslyActioned = 'dimension127'
}

export enum CustomIDScanErrors {
  CAMERA_INIT = 'EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE'
}

export enum BelgianRegulatorError {
  OLD_SERVICE = 1,
  DEFAULT_ERROR,
  PLAYER_EXISTS,
  BANNED,
  BANNED_ON_VALIDATION,
  MAJOR_ERROR,
  COMM_ERROR,
  ACC_RESTRICTED
}

export enum DeAddressVerificationResult {
  None = 'None',
  Success = 'Success',
  Failed = 'Failed',
  ServiceUnavailable = 'ServiceUnavailable'
}
